var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54817 0.786579C7.99074 0.202553 8.83972 0.0756133 9.44442 0.503051C10.0491 0.930488 10.1806 1.75044 9.73799 2.33447L5.36857 8.10046C5.00616 8.5787 4.30712 8.63233 3.876 8.21496L0.396265 4.8462C-0.132978 4.33384 -0.131957 3.50412 0.398547 2.99297C0.929051 2.48182 1.78815 2.48281 2.31739 2.99518L4.36923 4.98158L7.54817 0.786579Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/Checkmark.19ab732ee1f4c8729b546ad3d72dc41e.svg";
export { ForwardRef as ReactComponent };